module.exports = __webpack_public_path__ + "static/media/login.c15af127.svg";